<div
  class="tw-flex tw-flex-col tw-h-full tw-bg-white dark:tw-bg-gray-900 tw-rounded tw-overflow-hidden tw-shadow tw-shadow-gray-300 dark:tw-shadow-gray-700 tw-py-4">
  <div class="tw-px-4 sm:tw-px-8 tw-pt-6 tw-pb-3">
    <h2
      class="tw-text-xl sm:tw-text-2xl tw-font-semibold tw-text-gray-900 dark:tw-text-white tw-mt-0 tw-mb-2">
      {{ config.title }}
    </h2>
    <p
      class="lists-categories-description tw-text-sm tw-text-gray-600 dark:tw-text-gray-400 tw-my-0">
      {{ config.description }}
    </p>

    <button (click)="onCancel()" mat-icon-button class="tw-absolute tw-top-4 tw-right-4">
      <mat-icon class="tw-text-gray-600 dark:tw-text-gray-400">close</mat-icon>
    </button>
  </div>

  <div
    class="tw-px-4 sm:tw-px-8 tw-pt-0 tw-pb-4 sm:tw-py-4 tw-border-0 tw-border-b tw-border-solid tw-border-gray-200 dark:tw-border-gray-800"
    [class.tw-opacity-50]="isLoading">
    <div class="tw-relative tw-flex tw-items-center">
      <input
        type="text"
        [(ngModel)]="searchQuery"
        (ngModelChange)="onSearch()"
        [placeholder]="config.searchPlaceholder || 'Search...'"
        [disabled]="isLoading"
        class="sm:tw-min-w-[300px] tw-bg-gray-100 dark:tw-bg-gray-800 tw-text-gray-900 dark:tw-text-white tw-rounded-lg tw-py-2 tw-px-4 tw-pl-10 tw-pr-10 tw-border tw-border-solid tw-border-gray-300 dark:tw-border-gray-700 focus:tw-border-teal-500 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-teal-500 tw-transition-colors disabled:tw-opacity-50 disabled:tw-cursor-not-allowed" />
      <mat-icon class="tw-absolute tw-left-2 tw-top-[.4rem] tw-text-gray-600 dark:tw-text-gray-400"
        >search</mat-icon
      >
      <button *ngIf="searchQuery" (click)="clearSearch()" class="tw-ml-1" [disabled]="isLoading">
        <div
          class="tw-w-8 tw-h-8 tw-rounded-full tw-bg-teal-100 dark:tw-bg-teal-800 tw-bg-opacity-30 dark:tw-bg-opacity-30 tw-text-gray-600 dark:tw-text-gray-400 tw-flex tw-items-center tw-justify-center">
          <mat-icon class="tw-text-lg tw-font-bold tw-mb-1 tw-text-teal-500">close</mat-icon>
        </div>
      </button>
    </div>
  </div>

  <div
    *ngIf="config.tabs && config.tabs.length > 0"
    class="tw-px-4 sm:tw-px-8 tw-py-4 tw-border-0 tw-border-b tw-border-solid tw-border-gray-200 dark:tw-border-gray-800"
    [class.tw-opacity-50]="isLoading">
    <div
      class="tw-inline-flex tw-gap-2 tw-items-center tw-justify-between tw-rounded-full tw-border tw-border-solid tw-border-gray-300 dark:tw-border-gray-600 tw-bg-gray-100 dark:tw-bg-gray-700 tw-text-sm tw-font-medium">
      <button
        *ngFor="let tab of config.tabs"
        (click)="!isLoading && onTabChange(tab.id)"
        class="tw-px-5 tw-py-2 tw-rounded-full tw-transition-all tw-text-sm tw-font-medium tw-h-10 tw-whitespace-nowrap"
        [disabled]="isLoading"
        [ngClass]="{
          'tw-bg-[#102825] tw-font-medium tw-text-[#7FFFD4] tw-border-2 tw-border-solid tw-border-teal-900': activeTab === tab.id,
          'tw-text-gray-700 dark:tw-text-white hover:tw-bg-gray-200 dark:hover:tw-bg-gray-600': activeTab !== tab.id,
          'tw-cursor-not-allowed tw-opacity-50': isLoading
        }">
        {{ tab.label }}
      </button>
    </div>
  </div>

  <div class="tw-flex-1 tw-overflow-y-auto tw-px-4 md900:tw-px-6 lg:tw-px-8 tw-py-6">
    <!-- Loading spinner -->
    <div
      *ngIf="isLoading"
      class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-h-full tw-min-h-[300px]">
      <mat-spinner diameter="50" strokeWidth="4" class="tw-mb-4"></mat-spinner>
      <p class="tw-text-gray-600 dark:tw-text-gray-400 tw-text-base">Loading items...</p>
    </div>

    <ng-container *ngIf="!isLoading && shouldShowCategories()">
      <div *ngIf="(filteredCategories | keyvalue).length === 0" class="tw-text-center tw-py-12">
        <div class="tw-flex tw-flex-col tw-items-center tw-max-w-md tw-mx-auto">
          <div
            class="tw-w-20 tw-h-20 tw-rounded-full tw-bg-gray-100 dark:tw-bg-gray-800 tw-flex tw-items-center tw-justify-center tw-mb-4">
            <mat-icon class="tw-w-10 tw-h-10 tw-text-4xl tw-text-gray-400 dark:tw-text-gray-500">
              {{ searchQuery ? 'search_off' : 'remove_circle' }}
            </mat-icon>
          </div>
          <h3 class="tw-text-lg tw-font-medium tw-text-gray-800 dark:tw-text-gray-200 tw-mb-2">
            {{ searchQuery ? 'No items matching your search' : getActiveTab()?.emptyMessage || 'No items found' }}
          </h3>
          <p class="tw-text-sm tw-text-gray-600 dark:tw-text-gray-400 tw-leading-relaxed">
            {{ searchQuery ? 'Please try again with different keywords' : getActiveTab()?.emptyDescription || '' }}
          </p>
        </div>
      </div>
      <div *ngFor="let category of filteredCategories | keyvalue" class="tw-mb-8 last:tw-mb-0">
        <div class="tw-flex tw-items-center tw-justify-between tw-mb-3">
          <h3 class="tw-text-lg tw-font-medium tw-text-gray-700 dark:tw-text-gray-300 tw-my-0">
            {{ category.key }}
          </h3>
          <span
            class="tw-text-sm tw-text-gray-600 dark:tw-text-gray-400 tw-bg-gray-200 dark:tw-bg-gray-800 tw-bg-opacity-50 tw-px-3 tw-py-1 tw-rounded-full">
            {{ getItemCount(category.value) }}
          </span>
        </div>

        <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-3 tw-gap-4">
          <ng-container *ngFor="let item of category.value; trackBy: trackByItemId">
            <ng-container *ngTemplateOutlet="itemTemplate; context: { item: item }"></ng-container>
          </ng-container>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="!isLoading && !shouldShowCategories()">
      <div *ngIf="filteredItems.length === 0" class="tw-text-center tw-py-12">
        <div class="tw-flex tw-flex-col tw-items-center tw-max-w-md tw-mx-auto">
          <div
            class="tw-w-20 tw-h-20 tw-rounded-full tw-bg-gray-100 dark:tw-bg-gray-800 tw-flex tw-items-center tw-justify-center tw-mb-4">
            <mat-icon class="tw-w-10 tw-h-10 tw-text-4xl tw-text-gray-400 dark:tw-text-gray-500">
              {{ searchQuery ? 'search_off' : 'remove_circle' }}
            </mat-icon>
          </div>
          <h3 class="tw-text-lg tw-font-medium tw-text-gray-800 dark:tw-text-gray-200 tw-mb-2">
            {{ searchQuery ? 'No items matching your search' : getActiveTab()?.emptyMessage || 'No items found' }}
          </h3>
          <p class="tw-text-sm tw-text-gray-600 dark:tw-text-gray-400 tw-leading-relaxed">
            {{ searchQuery ? 'Please try again with different keywords' : getActiveTab()?.emptyDescription || '' }}
          </p>
        </div>
      </div>

      <div
        *ngIf="filteredItems.length > 0"
        class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 lgx:tw-grid-cols-3 tw-gap-4">
        <ng-container *ngFor="let item of filteredItems; trackBy: trackByItemId">
          <ng-container *ngTemplateOutlet="itemTemplate; context: { item: item }"></ng-container>
        </ng-container>
      </div>
    </ng-container>
  </div>
</div>

<ng-template #itemTemplate let-item="item">
  <ng-container
    *ngComponentOutlet="itemComponentClass; 
    injector: createItemInjector(item)">
  </ng-container>
</ng-template>
